import React from "react";

import {
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { TitleText } from "@/components/atoms";
import { buildModeOptions } from "@/utils";
import { SelectableMenuCard } from "@/components/molecules";

interface BuildModeSelectProps {
  value: string;
  onChange: (option: {value: string, label: string}) => void;
  disabled?: boolean;
}

const BuildModeSelect: React.FC<BuildModeSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {

  return (
    <Stack spacing={1} >
      <TitleText
        text="How targeted do you want to be?"
        subtext="
        A high reach results in a bigger audience but the insights will be less specific.
        High scoring allows you to focus on the core audience at the expense of audience size.
        "
        spacing={0.5}
      />
      <Stack direction="row" spacing={2}>
        {buildModeOptions.map((option, idx) => (
          <SelectableMenuCard
            key={idx}
            title={option.label}
            // text={option.description}
            hover={option.description}
            onClick={() => onChange(option)}
            icon={option.icon}
            selected={value === option.value}
            width="200px"
            // height="140px"
            disabled={disabled}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default BuildModeSelect;
